import { __extends } from "tslib";
import { ReadApiClient } from './ReadApiClient';
import { Globals } from '../Misc';
import { NeoTypes } from '../AppServices';
var UpdateableApiClient = /** @class */ (function (_super) {
    __extends(UpdateableApiClient, _super);
    function UpdateableApiClient(apiPath, axios) {
        if (axios === void 0) { axios = Globals.appService.get(NeoTypes.Axios); }
        return _super.call(this, apiPath, axios) || this;
    }
    /** Deletes an entity using the provided id. */
    UpdateableApiClient.prototype.delete = function (id) {
        return this.axios.delete("".concat(this.apiPath, "/").concat(id));
    };
    /** Inserts the entity. */
    UpdateableApiClient.prototype.post = function (model) {
        return this.axios.post(this.apiPath, model);
    };
    /** Updates the entity */
    UpdateableApiClient.prototype.put = function (id, model) {
        return this.axios.put("".concat(this.apiPath, "/").concat(id), model);
    };
    /** Saves the entity, using it's tracking state to determine the operation. */
    UpdateableApiClient.prototype.save = function (model) {
        return this.axios.post("".concat(this.apiPath, "/Save"), model);
    };
    /** Saves a list of entities, using each entities tracking state to determine the operation. */
    UpdateableApiClient.prototype.saveList = function (model) {
        return this.axios.post("".concat(this.apiPath, "/SaveList"), model);
    };
    return UpdateableApiClient;
}(ReadApiClient));
export { UpdateableApiClient };
